var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// DELIVERABLES
var DELIVERABLES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query Deliverables($per_page: Int) {\n    deliverables(per_page: $per_page, filters: { archived: false }) {\n      nodes {\n        id\n        display_name\n        group\n        description\n        name\n        group_position\n      }\n    }\n  }\n"], ["\n  query Deliverables($per_page: Int) {\n    deliverables(per_page: $per_page, filters: { archived: false }) {\n      nodes {\n        id\n        display_name\n        group\n        description\n        name\n        group_position\n      }\n    }\n  }\n"])));
export var useDeliverablesQuery = function (options) {
    return useQuery(DELIVERABLES, options);
};
export default DELIVERABLES;
var templateObject_1;
